<template>
  <div class="card card-custom card-stretch gutter-b col-12">
    <b-overlay :show="loading" variant="white" rounded="sm">
      <div class="card-body pt-3 pb-0">
        <div class="table-responsive">
          <div
            v-show="items.length == 0 && !loading"
            class="alert alert-custom alert-notice alert-light-warning fade show mb-5 mt-5"
            role="alert"
          >
            <div class="alert-icon">
              <i class="flaticon-warning"></i>
            </div>
            <div class="alert-text">
              <strong>Búsqueda sin resultados</strong>. Intente nuevamente
              buscando con otros parámetros.
            </div>
            <div class="alert-close"></div>
          </div>

          <table
            class="table table-head-custom table-vertical-center"
            v-show="items.length > 0 && !loading"
          >
            <thead>
              <tr class="text-left">
                <th style="min-width: 200px">Mes</th>
                <th style="min-width: 200px">UF</th>
                <th style="min-width: 200px">US$</th>
                <th style="min-width: 200px">UTM</th>
                <th style="min-width: 200px">EUR</th>
                <th style="min-width: 200px">Total General</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" v-bind:key="i">
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.mes
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.totalFormatPagadoUF
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.totalFormatPagadoUS
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.totalFormatPagadoUTM
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.totalFormatPagadoEUR
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                   formatearPesos( item.totalMonedaGeneralPagado)
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="page"
          :length="pages"
          v-if="pages > 1"
          :total-visible="10"
          min="1"
          step="1"
        ></v-pagination>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "dataTableInforme",
  // props: ["comision"],
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    loading: { type: Boolean, required: true },
    itemKey: String,
    customClickAction: Function,
    pagination: {
      type: Object,
      required: true,
    },
    pages: { type: Number, required: true },
  },
  watch: {
    page: {
      handler() {
        this.$emit("fetch-more", {
          page: this.page,
          page_size: this.pagination.page_size,
          filter: "",
        });
      },
      deep: true,
    },
  },
  computed: {
    // pages () {
    //   //console.log(("registros: " + this.pagination.totalRecords + " , paginas " + this.page_size)
    //     return Math.ceil(this.pagination.totalRecords / this.page_size);
    // }
  },
  data() {
    return {
      page: 2,
      page_size: this.pagination.page_size,
      comision: null,
      detalleLiquidacion: null,
    };
  },
  mounted() {},
  methods: {
    formatearPesos(moneda) {
      let monedaFormateada = new Intl.NumberFormat("es-CL");

      return monedaFormateada.format(moneda);
    },
    formatearDolar(moneda) {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });

      return monedaFormateada.format(moneda);
    },
    getColor(valor) {
      if (valor == "PAGADO") return "label-light-success";
      else if (valor == "NO PAGADO") return "label-light-danger";
      else if (valor == "FACTURA") return "label-light-success";
      else if (valor == "NO APROBADO") return "label-light-danger";
      else if (valor == "APROBADO") return "label-light-success";
      else if (valor == "BOLETA") return "label-light-primary";
      else if (valor == true) return "label-light-success";
      else if (valor == false) return "label-light-danger";
      else if (valor == "UF") return "label-light-success";
      else if (valor == "UTM") return "label-light-primary";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "Afecta") return "label-light-danger";
      else if (valor == "Excenta") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else return "label-light-success";
    },
    capitalizar(valor) {
      if (valor != null) {
        let texto = valor.toLowerCase();
        return texto.charAt(0).toUpperCase() + texto.slice(1);
      }
    },
  },
};
</script>
